import { ResourceModel } from "../../generics/models/generic-resource-model";
import { UserPreferences } from "./user-preferences.model";

export class User extends ResourceModel<User> {
  public id: number;
  public firstName!: string;
  public firstLastName!: string;
  public secondLastName: string;
  public avatarUrl!: string;
  public email!: string;
  public phoneNumber!: string;
  public isEnabled: boolean;
  public authAmount: number;
  public unlimitedAuthAmount: boolean;
  public password!: string;
  public roleID!: number;
  public preferencesID!: number;
  public preferences!: UserPreferences;
  public userTypeID!: number;
  public shelterID!: number;
  public corporateID!: number;
  public corporatePlantID!: number;
  public supplierID!: number;
  public isLegalRepresentative: boolean;

  public corporatePlantsHasAccess!: CorporatePlantHasAccessDTO[];

  constructor(model?: Partial<User>) {
    super(model);
  }
}

export class CorporatePlantHasAccessDTO {
  public id: number;
  public hasAccesss: boolean;
}
